module.exports = {
	FUTURE_FORECASTED: 'ismMeasured',
	FUTURE_RESERVED: 'soldImpressions',
};
